import React, { type CSSProperties } from 'react';

import { Button } from 'components/ui/button';
import googleIcon from 'assets/images/logos/google.svg';

interface Props {
  size?: React.ComponentProps<typeof Button>['size'];
  onClick: () => void;
}

// Google's sign-in branding guidelines: an approved label and the standard "G" on a white button, even on a tinted
// surface such as a warning alert, where Blueprint's outline variant would otherwise be transparent.
const WHITE_BUTTON = { '--bp-btn-bg': 'rgb(var(--bp-white-rgb))' } as CSSProperties;

export default function ContinueWithGoogleButton({ size, onClick }: Props) {
  return (
    <Button className="gap-2" size={size} style={WHITE_BUTTON} variant="outline" onClick={onClick}>
      <img alt="" src={googleIcon} style={{ width: 16, height: 16 }} />
      Continue with Google
    </Button>
  );
}
